var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.59 41.18C16.5177 41.18 12.5368 39.9724 9.15082 37.71C5.76481 35.4475 3.12574 32.2318 1.56733 28.4695C0.0089213 24.7071 -0.398829 20.5672 0.39564 16.5731C1.19011 12.579 3.15112 8.91024 6.03068 6.03068C8.91024 3.15112 12.579 1.19011 16.5731 0.39564C20.5672 -0.398829 24.7071 0.0089213 28.4695 1.56733C32.2318 3.12574 35.4475 5.76481 37.71 9.15082C39.9724 12.5368 41.18 16.5177 41.18 20.59C41.18 26.0508 39.0107 31.288 35.1493 35.1493C31.288 39.0107 26.0508 41.18 20.59 41.18ZM20.59 2.94144C17.0994 2.94144 13.6873 3.97651 10.785 5.91576C7.88269 7.85501 5.62063 10.6113 4.28485 13.8362C2.94908 17.061 2.59958 20.6096 3.28055 24.0331C3.96152 27.4566 5.64239 30.6012 8.11058 33.0694C10.5788 35.5376 13.7235 37.2185 17.1469 37.8995C20.5704 38.5804 24.119 38.2309 27.3438 36.8952C30.5687 35.5594 33.325 33.2973 35.2643 30.395C37.2035 27.4927 38.2386 24.0806 38.2386 20.59C38.2386 15.9093 36.3792 11.4203 33.0694 8.11058C29.7597 4.80083 25.2707 2.94144 20.59 2.94144V2.94144Z",
    fill: "#0A91BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3407 29.4142L19.1194 21.1929V7.35352H22.0608V19.9722L29.4144 27.3405L27.3407 29.4142Z",
    fill: "#0A91BF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.d06c9200.svg";
export { ForwardRef as ReactComponent };